module.exports = __webpack_public_path__ + "static/logo-21514a6c6f9bdca7961410ad0f9a591a.png";